/* GENRYZ wordmark. Two artwork variants ship in /public/images — pick by the
   background the logo sits on, not by the page's nominal theme:
     variant="light" → dark/black wordmark, for light backgrounds (default)
     variant="dark"  → silver/white wordmark, for dark backgrounds */
const SRC = {
  light: "/images/genryz-logo-light.png",
  dark: "/images/genryz-logo-dark.png",
};

export default function Logo({ className = "", variant = "light" }) {
  return (
    <img
      src={SRC[variant] || SRC.light}
      alt="GENRYZ — Educating The Genz Way"
      className={`w-auto object-contain ${className}`}
    />
  );
}
